import { Injectable } from '@angular/core';
// import { BehaviorSubject } from 'rxjs';
import { LoggerService } from '../Non-Master/logger.service';
// import { MatDateFormats } from '@angular/material';

var TAG = "DialogReplyService";


@Injectable({
  providedIn: 'root'
})

export class DateTimeConvertService {

  constructor(private log: LoggerService
  ) { }

  ConvertCurrentDayWeek(date: Date) {

    var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    var convertedDate = date.toLocaleDateString("zh-TW", options);

    return convertedDate;
  }

  ConvertCurrentDay(date: Date) {

    var options = { year: 'numeric', month: 'long', day: 'numeric' };
    var convertedDate = date.toLocaleDateString("zh-TW", options);

    return convertedDate;
  }

  GetCurrentTime(){
    var resultData = "";
    //var currentDateTime = Date.now;
    let now = new Date();
   // var options = { year: 'numeric', month: 'long', day: 'numeric' };
   // var convertedDate = now.toLocaleDateString("zh-TW", options);
    var hh = now.getHours(); // getMonth() is zero-based
    var mm = now.getMinutes();
    var ss = now.getSeconds();
    return [
      now.getFullYear(),
        '-', ('0' + (now.getMonth() + 1)).slice(-2),
        '-', ('0' + now.getDate()).slice(-2),
        ' ',(hh>9 ? '' : '0') + hh,
        ':',(mm>9 ? '' : '0') + mm,
        ':',(ss>9 ? '' : '0') + ss,

    ].join('');

  //  return convertedDate;
  }

  ConvertCurrentDBDay(date: Date) {

    return [
      date.getFullYear(),
        '-', ('0' + (date.getMonth() + 1)).slice(-2),
        '-', ('0' + date.getDate()).slice(-2)
    ].join('');

    // return [
    //   date.getFullYear(),
    //     '-', ('0' + (date.getMonth() + 1)).slice(-2),
    //     '-', ('0' + date.getDate()).slice(-2),
    //     ' ', date.toTimeString()
    // ].join('');
  }


  ConvertCurrentDateTime(date: Date) {
    var hh = date.getHours(); // getMonth() is zero-based
    var mm = date.getMinutes();
    var ss = date.getSeconds();
    return [
      date.getFullYear(),
        '-', ('0' + (date.getMonth() + 1)).slice(-2),
        '-', ('0' + date.getDate()).slice(-2),
        ' ',(hh>9 ? '' : '0') + hh,
        ':',(mm>9 ? '' : '0') + mm,
        ':',(ss>9 ? '' : '0') + ss,

    ].join('');
  }

  ConvertCurrentReportDay(date: Date) {

    return [
      date.getFullYear(),
        '-', ('0' + (date.getMonth() + 1)).slice(-2),
        '-', ('0' + date.getDate()).slice(-2)
    ].join('');

    // return [
    //   date.getFullYear(),
    //     '-', ('0' + (date.getMonth() + 1)).slice(-2),
    //     '-', ('0' + date.getDate()).slice(-2),
    //     ' ', date.toTimeString()
    // ].join('');
  }

  ConvertCurrentTime(date: Date) {

    var options = {hour: 'numeric', minute:'numeric'};
    var convertedDate = date.toLocaleTimeString("en-GB", options);

    return convertedDate;
  }
}

